// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsCollectionsForm_heading__U8uv0","form":"ReportingDetailsCollectionsForm_form__1TH6O"};